import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IGetShouldSuppressDataOrientationAutoOpenParams {
  user: string;
}

export interface IGetShouldSuppressDataOrientationAutoOpenResult extends IResult {
  shouldSuppressAutoOpen: boolean;
}

export class GetShouldSuppressDataOrientationAutoOpenRequest extends Request<IGetShouldSuppressDataOrientationAutoOpenParams, IResult> {
  constructor(params: IGetShouldSuppressDataOrientationAutoOpenParams) {
    super('getShouldSuppressDataOrientationAutoOpen', params);
  }
}
